var map = {
	"./arrow-down-fat.svg": 552,
	"./arrow-down.svg": 853,
	"./arrow-left.svg": 2,
	"./arrow-long-right.svg": 765,
	"./arrow-long-up.svg": 490,
	"./arrow-right.svg": 384,
	"./arrow-up.svg": 538,
	"./email.svg": 649,
	"./fax.svg": 28,
	"./pdf-download.svg": 959,
	"./phone.svg": 661,
	"./talk.svg": 392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;